import React from "react";
import github from "../assets/github-icon.svg";
import twitter from "../assets/twitter.svg";
import insta from "../assets/instagram.svg";
import linkedin from "../assets/linkedin.svg";
import { motion } from "framer-motion";

function SocialLinks() {
  return (
    <div className="flex gap-[30px] flex-col fixed top-[40%] md:top-[30%] md:right-[50px] right-[20px] ">
      <motion.a
        href="https://www.github.com/qozeemope"
        whileHover={{
          scale: 1.1,
          color: "white",
          boxShadow: "0px 0px 8px rgb(255, 255, 255)",
        }}
      >
        <img src={github} alt="" className="w-[20px] md:w-[30px] " />
      </motion.a>
      <motion.a
        href="https://www.linkedin.com/in/qozeemopeyemi266"
        whileHover={{
          scale: 1.1,
          color: "white",
          boxShadow: "0px 0px 8px rgb(255, 255, 255)",
        }}
      >
        <img src={linkedin} alt="" className="w-[20px] md:w-[30px]" />
      </motion.a>
      <motion.a
        href="https://www.twitter.com/qozeemope"
        whileHover={{
          scale: 1.1,
          color: "white",
          boxShadow: "0px 0px 8px rgb(255, 255, 255)",
        }}
      >
        <img src={twitter} alt="" className="w-[20px] md:w-[30px]" />
      </motion.a>
      <motion.a
        href="https://www.instagram.com/_qozeemope"
        whileHover={{
          scale: 1.1,
          color: "white",
          boxShadow: "0px 0px 8px rgb(255, 255, 255)",
        }}
      >
        <img src={insta} alt="" className="w-[20px] md:w-[30px]" />
      </motion.a>
    </div>
  );
}

export default SocialLinks;
